import axios from "axios"
import { API_URL } from "./data"

export const publicRequest = axios.create({
   baseURL: API_URL,
})

export const userRequest = axios.create({
   baseURL: API_URL,
})

userRequest.interceptors.request.use(
   (config) => {
      try {
         const root = localStorage.getItem("persist:root")
         if (!root) return config
         let parsedRoot
         try {
            parsedRoot = JSON.parse(root)
         } catch {
            return config
         }
         let userSlice
         try {
            userSlice = parsedRoot?.user ? JSON.parse(parsedRoot.user) : null
         } catch {
            userSlice = null
         }
         const token = userSlice?.currentUser?.accessToken
         if (token) {
            config.headers = config.headers || {}
            config.headers.Authorization = `Bearer ${token}`
         }
      } catch {
         // ignore and send without auth header
      }
      return config
   },
   (error) => Promise.reject(error)
)
